import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart } from 'react-chartjs-2';
import { monthsWithKeyValue } from '../../../slices/sliceUtil';
Chart.defaults.global.legend.display = false;

const TrendLines = ({
  trendLineData,
  buttonValue
}) => {
  let lineData = JSON.parse(JSON.stringify(trendLineData));
  let xAxisLabels = [];
  let monthNames = monthsWithKeyValue;
  return /*#__PURE__*/React.createElement(Line, {
    data: lineData,
    options: {
      tooltips: {
        titleAlign: 'center',
        bodyAlign: 'center',
        xPadding: 12,
        yPadding: 12,
        position: 'nearest',
        callbacks: {
          title: tooltipItem => {
            if (buttonValue === '1M' || buttonValue === '1W' && tooltipItem[0] && tooltipItem[0].xLabel) {
              var tooltipValue = tooltipItem[0].xLabel && tooltipItem[0].xLabel.split('/');
              return tooltipValue[1] + '-' + monthNames[tooltipValue[0]] + ' ' + tooltipValue[2];
            } else {
              return tooltipItem[0].xLabel;
            }
          },
          beforeBody: tooltipItem => Number(tooltipItem[0].yLabel),
          label: () => ''
        }
      },
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        xAxes: [{
          gridLines: {
            display: false
          },
          reverse: false,
          ticks: {
            callback: function (val, index) {
              let value = val.split('-');

              if (buttonValue === 'All' || buttonValue === '1Y') {
                if (xAxisLabels.includes(value[1])) {
                  return ' ';
                } else {
                  xAxisLabels.push(value[1]);
                  return value[1];
                }
              } else if (buttonValue === '6M') {
                let checkValue = value[0] === '15' ? value[0] + value[1] : value[1];
                const isLabelExist = xAxisLabels.find(label => label.match(checkValue));

                if (isLabelExist) {
                  return ' ';
                } else {
                  if (value[0] === '15') {
                    xAxisLabels.push(value[0] + value[1]);
                    return value[0] + ' ' + value[1];
                  } else {
                    xAxisLabels.push(value[1]);
                    return value[1];
                  }
                }
              } else if (buttonValue === '1M') {
                return index % 2 === 0 ? val : '';
              } else if (buttonValue === '1W') {
                return val;
              }
            },
            autoSkip: true,
            fontSize: 10,
            maxTicksLimit: 365,
            maxRotation: 0,
            minRotation: 0
          }
        }],
        yAxes: [{
          ticks: {
            min: 0,
            max: 100,
            stepSize: 20,
            fontSize: 10
          }
        }]
      }
    }
  });
};

export default TrendLines;